module.exports = __webpack_public_path__ + "img/phone-no.5154548d.svg";